import { FormattedDate } from 'react-intl';

import { HeadlinePill } from '@sorare/core/src/components/animations/AnimatedStory/HeadlinePill';

type Props = {
  startDate: Date;
  endDate: Date;
  colors?: { bg: string; fg: string };
};
export const GameweekDate = ({ startDate, endDate, colors }: Props) => {
  return (
    <HeadlinePill
      label={
        <>
          <FormattedDate value={startDate} month="short" day="numeric" /> -{' '}
          <FormattedDate value={endDate} month="short" day="numeric" />
        </>
      }
      colors={colors}
    />
  );
};
